import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="designation-fields"
export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.index = this.containerTarget.querySelectorAll("tr.designation-row").length
  }

  add(event) {
    event.preventDefault()

    const row = document.createElement("tr")
    row.className = "designation-row"
    row.innerHTML = `
      <td><input type="text" name="department[designations_attributes][${this.index}][name]" class="form-control" /></td>
      <td><input type="number" name="department[designations_attributes][${this.index}][seats]" class="form-control" min="0" /></td>
      <td></td>
    `
    this.containerTarget.appendChild(row)
    this.index++
  }
}
